var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auto-login"},[_c('div',{staticClass:"loading"},[_c('van-loading',{attrs:{"type":"spinner","size":"24px"}}),_c('p',[_vm._v("登录中...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }